import React, { useState } from 'react';
import './Styles.css';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { InputFieldWrapper, InputField, InputFieldAddon } from '@ids/react-input-field';
import { Ui24Search, Ui32ArrowSmUp, Ui32ArrowSmDown } from '@ids/react-icons';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';
import { useCustomerFiltering } from './Functions';
import OutsideClickHandler from '../../../Elements/OutsideClickHandler/OutsideClickHandler';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';

const CustomerRateLookup = ({ customerList, setFilteredCustomers, setExpandedRate, openModalForNewCustomer }) => {
  const [query, setQuery] = useState('');
  const [areSearchResultsOpen, setAreSearchResultsOpen] = useState(false);

  const closeDropdown = () => {
    if (areSearchResultsOpen) {
      setAreSearchResultsOpen(false);
    }
  };

  const list = useCustomerFiltering(query, customerList, setFilteredCustomers);

  return (
    <div className="commission-page_customer-lookup-container">
      <OutsideClickHandler
        onOutsideClick={() => {
          if (areSearchResultsOpen) {
            setAreSearchResultsOpen(false);
          }
        }}>
        <InputFieldWrapper
          onClick={() => {
            if (!areSearchResultsOpen) {
              setAreSearchResultsOpen(true);
            }
          }}>
          <InputFieldAddon>
            <Ui24Search aria-hidden />
          </InputFieldAddon>
          <InputField
            placeholder={formatMessage(Messages.commissionPage_customerLookupPlaceholder)}
            onChange={e => {
              setQuery(e.target.value);
            }}
            value={query}
            autoComplete="off"
          />
          <InputFieldAddon>
            <IconButton
              type={IconButtonType.PLAIN}
              variant={IconButtonVariant.QUIET}
              size={IconButtonSize.X_SMALL}
              onClick={closeDropdown}>
              {areSearchResultsOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
            </IconButton>
          </InputFieldAddon>
        </InputFieldWrapper>

        {areSearchResultsOpen && (
          <div className="commission-page_customer-lookup-result-container">
            <div className="commission-page_customer-lookup-result-title">
              <div>
                {formatMessage(Messages.commissionPage_customerSearchResults)}
                {list.length === 0 && formatMessage(Messages.commissionPage_customerLookupNotFound)}
              </div>
              {list.length === 0 && (
                <Button
                  size={ButtonSize.X_SMALL}
                  type={ButtonType.TEXT}
                  variant={ButtonVariant.QUIET}
                  onClick={() => {
                    openModalForNewCustomer();
                    setAreSearchResultsOpen(false);
                  }}>
                  {formatMessage(Messages.commissionPage_customerLookupNewButton)}
                </Button>
              )}
            </div>

            <div>
              {list?.map(customer => {
                return (
                  <div
                    className="clickable commission-page_customer-lookup-result-row"
                    key={customer.customerNumber}
                    onClick={() => {
                      setAreSearchResultsOpen(false);
                      setFilteredCustomers([customer]);
                      setExpandedRate(customer.customerNumber);
                      setQuery(customer.customerNumber);
                    }}>
                    <div className="commission-page_customer-lookup-result-first-column">{customer.customerNumber}</div>
                    <div className="commission-page_customer-lookup-result-second-column">{customer.legalNumber}</div>
                    <div>{customer.customerName}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
};

export default CustomerRateLookup;
